import React, { useRef, useEffect, useState } from 'react'
import { changeUserStatus, deleteUserProfile, getUsers } from './../utils/api'
import moment from 'moment'
import Pagination from 'react-js-pagination'
import ReactHTMLTableToExcel from 'react-html-table-to-excel'
import { store } from 'react-notifications-component'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { CSVLink } from "react-csv";

const headers = [
  { label: "S.No.", key: "index" },
  { label: "Phone", key: "primaryPhone" },
  { label: "Name", key: "firstName" },
  { label: "Onboard Status", key: "onBoardProcessCount" },
  { label: "Created At", key: "createdAt" },
  { label: "DOB", key: "dateOfBirth" },
  { label: "Age", key: "age" },
  { label: "Gender", key: "gender" },
  { label: "Location", key: "location" },
  { label: "Status", key: "status" },
]
const fileName = "rekindleUsers"

function Participants(props) {
  const [users, setUsers] = useState([])
  const [usersDownload, setUsersDownload] = useState([])
  const [startDate, setStartDate] = useState(null)
  const [endDate, setendDate] = useState(null)
  const downloadRef = useRef()
  const [queryData, setQueryData] = useState({ currentPage: 1, totalPages: 1, search: '', status: '', gender: '', startDate: '', endDate: '' })
  const [deleteProfileData, setDeleteProfileData] = useState({})

  useEffect(() => {
    getUserData()
  }, [queryData.currentPage])

  function pageChanged(page) {
    // if (!startDate || !endDate) {
    //   if (typeof startDate.getMonth !== 'function' || typeof endDate.getMonth !== 'function') {
    //     alert('kindly enter end date or clear start date')
    //   }
    // }
    if (startDate) {
      if (endDate) {
        let PresentDate = new Date()

        let temp = { ...queryData }
        let getUsersFlag = false
        if (temp.currentPage === 1 && page === 1) {
          getUsersFlag = true
        }
        temp.currentPage = page
        setQueryData(temp)

        if (getUsersFlag) {
          getUserData()
        }
      } else {
        alert('kindly enter end date or clear start date')
      }
    } else {
      if (endDate) {
        alert('kindly enter start date or clear end date')
      }
      let PresentDate = new Date()

      let temp = { ...queryData }
      let getUsersFlag = false
      if (temp.currentPage === 1 && page === 1) {
        getUsersFlag = true
      }
      temp.currentPage = page
      setQueryData(temp)

      if (getUsersFlag) {
        getUserData()
      }
    }
  }

  useEffect(() => { getUserDataToDownload() }, [])

  async function getUserDataToDownload() {
    try {
      let response = await getUsers({ ...queryData, download: true })
      if (response) {
        let temp = []
        temp = response.data.users
        const usersData = temp.map((user, i) => (
          {
            index: i + 1,
            primaryPhone: user.primaryPhone,
            firstName: user.firstName,
            onBoardProcessCount: user.onBoardProcessCount,
            createdAt: moment(user.createdAt).format('DD-MM-YYYY'),
            dateOfBirth: moment(user.dateOfBirth).format('DD-MM-YYYY'),
            age: user.age || '',
            gender: user.gender?.toUpperCase() || '',
            location: user.location ? user.location?.city + ", " + user.location?.state : '',
            status: user.status?.toUpperCase()
          }))
        setUsersDownload(usersData || [])
      }
    } catch (err) {
      console.log(err)
    }
  }
  async function getUserData() {
    try {
      let response = await getUsers(queryData)
      if (response) {
        let temp = []
        temp = response.data.users
        setUsers(temp)
        let tempData = { ...queryData }
        tempData.totalPages = response.data.totalPages
        setQueryData(tempData)
      }
    } catch (err) {
      console.log(err)
    }
  }

  function inputValueChanged(event) {
    let temp = { ...queryData }
    temp[event.target.name] = event.target.value
    setQueryData(temp)
  }

  async function blockUsers(user, index, status) {
    try {
      let response = await changeUserStatus({ userIds: [user._id], status: status })
      let temp = [...users]
      temp[index].status = status
      setUsers(temp)
    } catch (error) {
      console.log(error)
    }
  }

  function goToProfile(user) {
    props.history.push(`/admin/profile?user=${user._id}`)
  }

  async function deleteProfile() {
    try {
      await deleteUserProfile({ userId: deleteProfileData._id })
      getUserData()
      store.addNotification({
        title: 'User Delete Successfully !!!',
        message: `Name - ${deleteProfileData.firstName}`,
        type: 'success',
        insert: 'top',
        container: 'top-right',
        animationIn: ['animate__animated', 'animate__fadeIn'],
        animationOut: ['animate__animated', 'animate__fadeOut'],
        dismiss: {
          duration: 3000,
          onScreen: true,
        },
      })
    } catch (err) {
      getUserData()
      console.log(err)
    }
  }

  function getOnboardStatus(user) {
    return user.onBoardProcessCount === 13 ? 'Completed' : `In Completed (${user.onBoardProcessCount})`
  }

  function setDeleteProfile(item) {
    setDeleteProfileData({ ...item })
  }

  return (
    <div className="content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <form>
              <div className="form-row">
                <div className="form-group col-md-3">
                  <label htmlFor="inputEmail4">Name/Email/Phone/City</label>
                  <input type="text" className="form-control" value={queryData.search} name="search" onChange={inputValueChanged} />
                </div>
                <div className="form-group col-md-3">
                  <label htmlFor="inputState">Gender</label>
                  <select id="inputState" className="form-control" value={queryData.gender} name="gender" onChange={inputValueChanged}>
                    <option value="" selected>
                      All
                    </option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                  </select>
                </div>
                <div className="form-group col-md-4">
                  <label htmlFor="inputState">Status</label>
                  <select id="inputState" className="form-control" value={queryData.status} name="status" onChange={inputValueChanged}>
                    <option value="" selected>
                      All
                    </option>
                    <option value="active">Active</option>
                    <option value="block">Block</option>
                  </select>
                </div>

                <div className="form-group col-md-4">
                  <label htmlFor="inputState" style={{ marginRight: '10px' }}>
                    Start Date
                  </label>
                  <DatePicker
                    className="form-control width-control"
                    selected={startDate}
                    maxDate={new Date()}
                    isClearable
                    placeholderText="Kindly select a date"
                    onChange={(date) => {
                      let Date2 = null
                      if (date) {
                        let Date1 = new Date(date)
                        Date2 = moment(Date1).format('YYYY-MM-DD')
                      }

                      setQueryData((prevState) => {
                        return { ...prevState, startDate: Date2 }
                      })

                      setStartDate(date)
                    }}
                  />
                </div>
                <div className="form-group col-md-4">
                  <label htmlFor="inputState" style={{ marginRight: '10px' }}>
                    End Date
                  </label>
                  <DatePicker
                    className="form-control"
                    selected={endDate}
                    minDate={startDate}
                    maxDate={new Date()}
                    isClearable
                    placeholderText="Kindly select a date"
                    onChange={(date) => {
                      let Date2 = null
                      if (date) {
                        let Date1 = new Date(date)
                        Date2 = moment(Date1).format('YYYY-MM-DD')
                      }

                      setendDate(date)
                      setQueryData((prevState) => {
                        return { ...prevState, endDate: Date2 }
                      })
                    }}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col-md-6">
                  {usersDownload.length ? <CSVLink ref={downloadRef} headers={headers} data={usersDownload} filename={fileName}>
                    <button type='button'>Export Users</button>
                  </CSVLink> : ''}
                </div>
              </div>

              <button
                type="button"
                onClick={(e) => {
                  pageChanged(1)
                }}
                className="btn btn-primary"
              >
                Apply
              </button>
            </form>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card card-plain table-plain-bg">
              <div className="card-header">
                <h4 className="card-title">Users List - {queryData.totalPages}</h4>
                <p className="card-category">users who have registered on your app</p>
              </div>
              <div className="card-header"></div>
              <div className="card-body table-full-width table-responsive">
                <table className="table table-hover" id="table-to-xls">
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>Phone/Email</th>
                      <th>Name</th>
                      <th>Onboard Status</th>
                      <th>Created At</th>
                      <th>DOB</th>
                      <th>Age</th>
                      <th>Gender</th>
                      <th>Location</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          {item.primaryPhone}
                          {item.primaryEmail}
                        </td>
                        <td style={{ cursor: "pointer" }} onClick={(e) => {
                          goToProfile(item)
                        }}>
                          {item.firstName}
                        </td>
                        <td>{getOnboardStatus(item)}</td>
                        <td>{moment(item.createdAt).format('DD-MM-YYYY')}</td>

                        <td>{moment(item.dateOfBirth).format('DD-MM-YYYY')}</td>
                        <td>{item.age}</td>
                        <td>{item.gender}</td>
                        {item.location && <td>{item.location.city}</td>}
                        {!item.location && <td></td>}
                        <td>{item.status}</td>
                        <td>
                          <div className="dropdown">
                            <button
                              className="btn btn-secondary dropdown-toggle"
                              type="button"
                              id="dropdownMenu2"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              Actions
                            </button>
                            <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                              <button
                                className="dropdown-item"
                                onClick={(e) => {
                                  goToProfile(item)
                                }}
                                type="button"
                              >
                                View Profile
                              </button>
                              <button
                                className="dropdown-item"
                                onClick={(e) => {
                                  setDeleteProfile(item)
                                }}
                                data-toggle="modal"
                                data-target="#exampleModal"
                                type="button"
                              >
                                Delete User
                              </button>
                              {item.status === 'active' && (
                                <button
                                  className="dropdown-item"
                                  onClick={(e) => {
                                    blockUsers(item, index, 'block')
                                  }}
                                  type="button"
                                >
                                  Block
                                </button>
                              )}
                              {item.status === 'block' && (
                                <button
                                  className="dropdown-item"
                                  onClick={(e) => {
                                    blockUsers(item, index, 'active')
                                  }}
                                  type="button"
                                >
                                  Active
                                </button>
                              )}
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <Pagination
              activePage={queryData.currentPage}
              itemsCountPerPage={10}
              totalItemsCount={queryData.totalPages}
              pageRangeDisplayed={5}
              itemClass="page-item"
              linkClass="page-link"
              onChange={pageChanged}
            />
          </div>
        </div>
      </div>
      <div className="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Confirm User Deletion
              </h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">Are You Sure you want to delete User ?</div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal">
                Close
              </button>
              <button type="button" onClick={deleteProfile} data-dismiss="modal" className="btn btn-danger">
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { Participants }
